import React, { useEffect, useState } from 'react';
import { useLanguage } from '../../../context/LanguageContext';
import { useNavigate } from 'react-router-dom';
import { fetchUser } from '../../../api/api_users';
import { deleteCustomPlant } from '../../../api/api_customPlants';
import { fetchCustomPlantsForUser } from '../../../api/api_users';
import PlantDetailsModal from '../Plants/PlantDetailsModal';
import defaultPlant from '../../assets/plants/defaultPlant.jpg';

function MyCustomPlants() {
  const { translations } = useLanguage();
  const navigate = useNavigate();
  const [user, setUser] = useState(null);
  const [customPlants, setCustomPlants] = useState([]);
  const [lockStates, setLockStates] = useState({});
  const [showPlantModal, setShowPlantModal] = useState(false);
  const [selectedCustomPlant, setSelectedCustomPlant] = useState(null);

  useEffect(() => {
    const token = localStorage.getItem('userToken');
    fetchUser(token)
      .then(data => setUser(data.data))
      .catch(() => {
        navigate('/login');
      });
  }, [navigate]);

  useEffect(() => {
    const fetchCustomPlants = async () => {
      try {
        const response = await fetchCustomPlantsForUser();
        setCustomPlants(response.data || []);
      } catch {}
    };
    fetchCustomPlants();
  }, []);

  const handleEditCustomPlant = (customPlant) => {
    navigate(`/customPlants/edit/${customPlant.id}`, { state: { customPlant } });
  };

  const handleCreateCustomPlant = () => {
    navigate('/customPlants/create');
  };

  const handleDelete = (id) => {
    const token = localStorage.getItem('userToken');
    if (window.confirm(translations.delete_custom_plant_confirm)) {
      deleteCustomPlant(id, token);
      setCustomPlants(prevCustomPlants =>
        prevCustomPlants.filter(customPlant => customPlant.id !== id)
      );
    }
  };

  const handleHome = () => {
    navigate('/home');
  };

  const handleToggleLock = (id) => {
    setLockStates(prev => ({
      ...prev,
      [id]: !prev[id]
    }));
  };

  const handleShowPlantDetails = (customPlant) => {
    setSelectedCustomPlant(customPlant);
    setShowPlantModal(true);
  };

  return (
    <div className="general-page">
      {showPlantModal && selectedCustomPlant && (
        <PlantDetailsModal
          isCustom={true}
          customPlantObj={selectedCustomPlant}
          onClose={() => setShowPlantModal(false)}
          translations={translations}
        />
      )}
      <div className="sm-container">
        <div className="header">
          <button onClick={handleHome} className="back-button">&#8592;</button>
          <h1>{translations.custom_plants}</h1>
        </div>
        <div className="help-info">
          <h3>{translations.my_custom_plants}</h3>
          {customPlants.length > 0 ? (
            <div>
              <ul className="sm-space-list">
                {customPlants.map((customPlant) => (
                  <div className="help-container" key={customPlant.id}>
                    <div className="space-header sm-space-header">
                      <div
                        className="custom-plant-row"
                        onClick={() => handleShowPlantDetails(customPlant)}
                      >
                        <img
                          src={defaultPlant}
                          alt={customPlant.name}
                          className="custom-plant-img"
                        />
                        <span className="custom-plant-name">{customPlant.name}</span>
                      </div>
                      <div className="custom-plant-actions">
                        <button
                          onClick={() => handleToggleLock(customPlant.id)}
                          className="general-button secondary-button little-button"
                          aria-label={lockStates[customPlant.id] ? 'Unlock' : 'Lock'}
                        >
                          {lockStates[customPlant.id]
                            ? <i className="fi fi-rr-unlock"></i>
                            : <i className="fi fi-rr-lock"></i>
                          }
                        </button>
                        <button
                          onClick={() => handleEditCustomPlant(customPlant)}
                          className="general-button edit-button little-button"
                        >
                          <i className="fi fi-rr-pencil"></i>
                        </button>
                        <button
                          onClick={() => handleDelete(customPlant.id)}
                          className="general-button delete-button little-button"
                        >
                          <i className="fi fi-rr-trash"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                ))}
              </ul>
            </div>
          ) : (
            <p>{translations.no_custom_plants_found}</p>
          )}
        </div>
        <button onClick={handleCreateCustomPlant} className="general-button create-custom-plant-btn">
          {translations.create_custom_plant}
        </button>
      </div>
    </div>
  );
}

export default MyCustomPlants;
